import React, { useMemo } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';

import { buildAddressMapUrl } from './orderApi';

/**
 * Event / delivery address with optional Google Maps link.
 */
const EventLocationMapLink = ({
    address,
    formattedAddress,
    className = '',
    emptyText = '—',
    showText = true,
}) => {
    const display = (formattedAddress ?? address ?? '').trim();
    const mapUrl = useMemo(
        () => buildAddressMapUrl(null, display),
        [display]
    );

    if (!display) {
        return showText ? <span>{emptyText}</span> : null;
    }

    return (
        <span className={`order-details-address-row event-location-map-link${className ? ` ${className}` : ''}`}>
            {showText ? <span>{display}</span> : null}
            {mapUrl ? (
                <a
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="order-details-map-icon-link"
                    aria-label="Open location in Google Maps"
                    title="Open in Google Maps"
                    onClick={(e) => e.stopPropagation()}
                >
                    <FaMapMarkerAlt aria-hidden />
                </a>
            ) : null}
        </span>
    );
};

export default EventLocationMapLink;
